<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 0px"
							(click)="onRefresh()"
						>
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="
								SelectedPerson == undefined || isProcessing == true || loading == true || SelectedClassAttendanceStudentHistory == undefined
							"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onViewHistory()"
						>
							View History
						</button>

						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true || SelectedEntry == undefined"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintHistory()"
						>
							Print History
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstClassAttendanceStudentHistory"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedClassAttendanceStudentHistory"
						dataKey="ClassAttendanceStudentHistoryID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--c_date-->
								<th>
									<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ClassAttendanceStatusDesc-->
								<th>
									<p-columnFilter field="ClassAttendanceStatusDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterClassAttendanceStatusDesc
												[ngModel]="value"
												[options]="lstClassAttendanceStatusDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ClassAttendanceExcuseDesc-->
								<th>
									<p-columnFilter field="ClassAttendanceExcuseDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterClassAttendanceExcuseDesc
												[ngModel]="value"
												[options]="lstClassAttendanceExcuseDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ClassAttendanceEntryTypeDesc-->
								<th>
									<p-columnFilter field="ClassAttendanceEntryTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterClassAttendanceEntryTypeDesc
												[ngModel]="value"
												[options]="lstClassAttendanceEntryTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--c_PersonName-->
								<th>
									<p-columnFilter type="text" field="c_PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--c_PersonTypeDesc-->
								<th>
									<p-columnFilter field="c_PersonTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterc_PersonTypeDesc
												[ngModel]="value"
												[options]="lstc_PersonTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--c_PersonTitle-->
								<th>
									<p-columnFilter field="c_PersonTitle" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterc_PersonTitle
												[ngModel]="value"
												[options]="lstc_PersonTitle"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--RecordStatusDesc-->
								<th>
									<p-columnFilter field="RecordStatusDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterRecordStatusDesc
												[ngModel]="value"
												[options]="lstRecordStatusDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="c_date">Date/Time<p-sortIcon field="c_date"></p-sortIcon></th>
								<th pSortableColumn="ClassAttendanceStatusDesc">Status<p-sortIcon field="ClassAttendanceStatusDesc"></p-sortIcon></th>
								<th pSortableColumn="ClassAttendanceExcuseDesc">Excuse<p-sortIcon field="ClassAttendanceExcuseDesc"></p-sortIcon></th>
								<th pSortableColumn="ClassAttendanceEntryTypeDesc">
									Entry Method<p-sortIcon field="ClassAttendanceEntryTypeDesc"></p-sortIcon>
								</th>
								<th pSortableColumn="c_PersonName">Created By<p-sortIcon field="c_PersonName"></p-sortIcon></th>
								<th pSortableColumn="c_PersonTypeDesc">Person Type<p-sortIcon field="c_PersonTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="c_PersonTitle">Person Title<p-sortIcon field="c_PersonTitle"></p-sortIcon></th>
								<th pSortableColumn="RecordStatusDesc">Record Status<p-sortIcon field="RecordStatusDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-ClassAttendanceStudentHistory>
							<tr [pSelectableRow]="ClassAttendanceStudentHistory" (dblclick)="onRowDblClick(ClassAttendanceStudentHistory)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ ClassAttendanceStudentHistory[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
